import { getMetabaseJWTSchema } from './getMetabaseJWT.schema';

export const getMetabaseJWT = () => {
  return {
    endpoint: `/internal/metabase/auth`,
    method: 'GET',
    responseSchema: getMetabaseJWTSchema,
  } as const;
};
